/**
 * @file useMount
 * @author chenbo09
 */

import useEffectOnce from '../effectOnce';

export default (fn: () => void): void => {
    useEffectOnce(() => {
        fn();
    });
};
